import React, { useCallback } from "react";
import { Col, Form, Input, Modal, Row, Select } from "antd";
import { EditDocumentIcon } from "../../../resource/icons";
import { actions as newDocumentActions } from "../store/actions/new-document.actions";

import actions from "../store/actions/edit-document.actions";
import { dspxGetChildrens } from "../../../helpers/dspx-utils";
import { useDispatch, useSelector } from "react-redux";

const EditAddressModal = ({
	validateFields,
	editAddressConnectId,
	visible,
	onCancel,
	prepareDataAndResetFields,
	getFieldDecorator,
	resetFields,
}) => {
	const dispatch = useDispatch();

	const listAddrStreet = useSelector(
		(store) => store.newDocumentStore.listAddrStreet
	);
	const listAddrBuilding = useSelector(
		(store) => store.newDocumentStore.listAddrBuilding
	);
	const listAddrFlat = useSelector(
		(store) => store.newDocumentStore.listAddrFlat
	);
	const valueAddrStreet = useSelector(
		(store) => store.newDocumentStore.valueAddrStreet
	);const valueAddrBuilding = useSelector(
		(store) => store.newDocumentStore.valueAddrBuilding
	);const valueAddrFlat = useSelector(
		(store) => store.newDocumentStore.valueAddrFlat
	);


	const subject = editAddressConnectId ? "Заменить адрес МКД" : "Адрес МКД";
	const subject_err = "адрес клиента";
	const onAddressChanged = useCallback(() => {
		validateFields((err, values) => {
			if (err) return;
			const v = prepareDataAndResetFields(values);
			if (v.editAddressConnectId) {
				dispatch(actions.updateAddress(v.editAddressConnectId, v.addressId));
			} else {
				dispatch(actions.addAddress(v.id, v.addressId));
			}
			dispatch(actions.closeModal());
		});
	}, [validateFields]);

	const handleAddrStreetChange = (value) => {
		resetFields(["addressId"]);
		dispatch(newDocumentActions.applyAddrStreet(value));
	};

	const handleAddrBuildingChange = (value) => {
		resetFields(["addressId"]);
		dispatch(newDocumentActions.applyAddrBuilding(value));
	};

	return (
		<Modal
			style={{ minWidth: 550 }}
			width={550}
			visible={visible}
			title={
				<span>
					<EditDocumentIcon
						style={{
							height: 40,
							verticalAlign: "middle",
							marginRight: 10,
						}}
					/>
					{subject}
				</span>
			}
			okText="Добавить"
			onCancel={onCancel}
			onOk={onAddressChanged}
		>
			<Form layout="vertical">
				<Row gutter={8}>
					<Col span={24}>
						<Form.Item label={"Адрес МКД"}>
							<Input.Group compact>
								<Select
									showSearch
									style={{ width: 248 }}
									placeholder="Улица"
									notFoundContent="нет данных"
									value={
										listAddrStreet &&
										listAddrStreet.some((e) => e.id == valueAddrStreet)
											? "" + valueAddrStreet
											: undefined
									}
									onChange={handleAddrStreetChange}
									optionLabelProp="label"
									optionFilterProp="searchtext"
								>
									{dspxGetChildrens(listAddrStreet)}
								</Select>
								<Select
									showSearch
									style={{ width: 120 }}
									notFoundContent="нет данных"
									placeholder="Дом"
									optionFilterProp="searchtext"
									value={
										listAddrBuilding &&
										listAddrBuilding.some((e) => e.id == valueAddrBuilding)
											? "" + valueAddrBuilding
											: undefined
									}
									onChange={handleAddrBuildingChange}
								>
									{dspxGetChildrens(listAddrBuilding)}
								</Select>
								{getFieldDecorator("addressId", {
									initialValue:
										listAddrFlat &&
										listAddrFlat.some((e) => e.id == valueAddrFlat)
											? "" + valueAddrFlat
											: undefined,
									rules: [
										{
											required: true,
											message: "Пожалуйста, выберите адрес.",
										},
									],
								})(
									<Select
										showSearch
										notFoundContent="нет данных"
										style={{ width: 120 }}
										placeholder="Кв./офис"
										optionFilterProp="searchtext"
									>
										{dspxGetChildrens(listAddrFlat)}
									</Select>
								)}
							</Input.Group>
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
};

export default EditAddressModal;
